/* unplugin-vue-components disabled */import { render } from "./input-files.vue?vue&type=template&id=5badd46c&scoped=true"
import script from "./input-files.vue?vue&type=script&lang=js"
export * from "./input-files.vue?vue&type=script&lang=js"

import "./input-files.vue?vue&type=style&index=0&id=5badd46c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5badd46c"],['__file',"src/components/chat-input/input-files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5badd46c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5badd46c', __exports__)) {
    api.reload('5badd46c', __exports__)
  }
  
  module.hot.accept("./input-files.vue?vue&type=template&id=5badd46c&scoped=true", () => {
    api.rerender('5badd46c', render)
  })

}


export default __exports__